// Stimulus controller manifest -- maintained by hand.
//
// Explicit imports + registrations, not an eager-loading glob: esbuild bundles
// this file statically and cannot resolve a runtime directory scan, so a glob
// here silently registers nothing. Add a line per controller.
//
// Copied from parsons-timesheet minus its page-specific controllers
// (entry-preview, pdf-preview, period-strip). `photo-picker` (milestone 4),
// `odometer-helper` and `unsaved-notes` (milestone 5) are this app's own. An
// unregistered controller makes `data-controller` a silent no-op, which is
// the trap this file's hand-kept list exists to avoid.
//
// The shell's dropdowns (topbar identity menu, footer) are DashWind
// `.dropdown` / `.dropdown-toggle` / `.show` markup driven by the DELEGATED
// handler in ../application.js -- do not add a Stimulus `dropdown` controller
// over the same markup; two systems would fight over one element.

import { application } from "./application"

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import OdometerHelperController from "./odometer_helper_controller"
application.register("odometer-helper", OdometerHelperController)

import PhotoPickerController from "./photo_picker_controller"
application.register("photo-picker", PhotoPickerController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import UnsavedNotesController from "./unsaved_notes_controller"
application.register("unsaved-notes", UnsavedNotesController)
